import { Loader2 } from 'lucide-react';

/**
 * Full-screen loading overlay that blocks all user interactions
 * Used during file uploads (libretto, bolla lavori)
 */
const LoadingOverlay = ({ isVisible, message = "Caricamento in corso...", submessage = "Attendere prego, non chiudere la pagina" }) => {
  if (!isVisible) return null;
  
  return (
    <div 
      className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[9999] flex items-center justify-center"
      data-testid="loading-overlay"
    >
      <div className="bg-zinc-900 border border-zinc-700 rounded-2xl p-8 max-w-sm mx-4 text-center shadow-2xl">
        <div className="relative mb-6">
          {/* Animated rings */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 border-4 border-primary/20 rounded-full animate-ping" />
          </div>
          <div className="relative flex items-center justify-center">
            <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin" />
            <Loader2 className="absolute w-8 h-8 text-primary animate-pulse" />
          </div>
        </div>
        
        <h3 className="text-xl font-semibold text-white mb-2">
          {message}
        </h3>
        <p className="text-zinc-400 text-sm">
          {submessage}
        </p>
        
        {/* Progress dots animation */}
        <div className="flex justify-center gap-1.5 mt-4">
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <span className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
